import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  navigate(event) {
    const url = this.element.dataset.href;
    if (url) {
      window.location.href = url;
    }
  }
}